<template lang="pug">
  .uploaded-file-display
    span(
      v-if="!fileName"
      :style="{ display: 'inline-block', width: width }"
      :class="{ limitWidth: width }"
    )
    a.file-name(
      v-if="fileName && fileNameList.length === 0"
      :href="downloadUrl"
      :style="{ width: width }"
      :class="{ limitWidth: width }"
      :title="fileName"
      target="_blank"
    ) {{ fileName }}
    el-tooltip(
      v-if="fileNameList.length !== 0"
      effect="light",
      placement="right",
    )
      a(
        :href="downloadUrl"
        :style="{ width: width }"
        :class="{ limitWidth: width }"
        target="_blank"
      ) {{ fileName }}
      div(slot="content")
        p(
          v-for="(file,index) of fileNameList",
          :key="index",
          style="margin-right: 20px;",
        ) {{ file }}
</template>

<script>
export default {
  props: {
    fileName: {
      type: String,
      default () {
        return null
      }
    },
    downloadUrl: {
      type: String,
      default () {
        return null
      }
    },
    fileNameList: {
      type: Array,
      default () {
        return []
      }
    },
    width: {
      type: String,
      default () {
        return null
      }
    }
  }
}
</script>

<style lang="stylus">
.uploaded-file-display
  display flex
  align-items center
  color $main

.limitWidth
  display: inline-block
  text-overflow: ellipsis
  overflow: hidden
  white-space: nowrap
</style>
